import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../../i18n/it";
import { FormGroup } from "@angular/forms";
import { ContractService } from "../../../../../auth/service/contract.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { AuthenticationService } from "../../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import * as moment from "moment/moment";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { BargainingService } from "../../bargaining.service";
import { RequestService } from "../../../requests/request.service";
import { ManageBargainingContractService } from "../../../../../auth/service/manage-bargaining-contract.service";
import { CandidateService } from "../../../candidates/candidate.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ListService } from "app/auth/service/list.service";

@Component({
  selector: "app-create-bargaining",
  templateUrl: "./create-bargaining.component.html",
  styleUrls: ["./create-bargaining.component.scss"],
})
export class CreateBargainingComponent implements OnInit {
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public contracts: any = [];
  public currentUser: any;
  public idRequest: string = "";
  public request: any = {};
  public today_date: string;
  public activeTab: string;

  protected company_offices_list: any = [];

  constructor(
    public _contractService: ContractService,
    public _contractManager: ManageBargainingContractService,
    private _changeDetectorRef: ChangeDetectorRef,
    public _citiesService: CitiesService,
    public _authenticationService: AuthenticationService,
    private _activatedRoute: ActivatedRoute,
    public _userFigureService: UserFigureService,
    public _bargainingService: BargainingService,
    public _utilService: UtilsService,
    private _router: Router,
    private requestService: RequestService,
    public _candidateService: CandidateService,
    protected _listService: ListService,
  ) {
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      const userIdentifier: any = params.get("user_identifier");
      if (!this._authenticationService.hasCapability("create_bargaining") && userIdentifier) {
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      }
      if (userIdentifier) {
        this._utilService.disableAutoHideLoading();
        await this.loadUserData(userIdentifier);
      }
    });
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      this.idRequest = params.get("id");
    });
    this.today_date = moment().format("YYYY-MM-DD");
  }

  async ngOnInit() {
    this.request = await this.requestService.getRequest(Number(this.idRequest));
    this.contracts = await this._contractService.getList();
    this.company_offices_list = await this._listService.getList('company_office');
  }

  ngOnDestroy() {
    this._contractManager.resetData();
  }

  transformRal(value: any) {
    value = this._utilService.fixRal(value);
    this._contractManager.changeSalaryGrossYearly(value);
  }

  transformTicketValue(target: any) {
    let { value }: any = target;
    if (value.split(",").length > 2) {
      value = value.split(",");
      const decimals: string = value.pop();
      value = value.join(".");
      value += "," + decimals;
    } else if (!value.includes(",")) {
      value += ",00";
    } else {
      value = value.replace(",", ".");
    }

    target.value = value;
    this._contractManager.data.ticket_value = value;
    this._contractManager.updateData("ticket");
  }

  async loadUserData(identifier: any) {
    this.currentUser = await this._candidateService.getCandidate(identifier).catch(async () => {
      await this._utilService.showToastrError("NOT_FOUND_CANDIDATE");
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    });
    if (Object.keys(this.currentUser.contract).length > 0) {
      await this._contractManager.init({
        level: this.currentUser.contract.desired_level,
        contract_name: this.currentUser.contract.desired_contract_type_name,
        contract: Number(this.currentUser.contract.desired_contract_type_id),
        salary_yearly_gross: this.currentUser.contract.desired_salary_gross_yearly,
        net_monthly_12: this.currentUser.contract.desired_net_monthly_12,
        net_monthly_13: this.currentUser.contract.desired_net_monthly_13,
        bonus: this.currentUser.contract.desired_bonus,
        ticket_value: this.currentUser.contract.desired_ticket_monthly_value,
        total_daily: this.currentUser.contract.desired_total_daily,
        total_net_monthly_13: this.currentUser.contract.desired_total_net_monthly_13,
        gross_monthly_12: this.currentUser.contract.desired_salary_gross_yearly / 12,
        ticket_month_number: 20,
        trial: null,
        role: this.currentUser.figure_id,
      });
      this._changeDetectorRef.detectChanges();
    } else {
      await this._contractManager.init();
    }

    this._contractManager.data.record_type = "desiderata";

    this._utilService.hideLoading();
    this._changeDetectorRef.detectChanges();

    this.currentUser.apprenticeship = 100;
    if (this.currentUser && this.currentUser.birthday) {
      this.currentUser.apprenticeship = moment().diff(this.currentUser.birthday, "years");
    }

    if (this.currentUser) {
      this.contentHeader = {
        headerTitle: italian.data.CREATE_BARGAINING + " " + italian.data.FOR + " " + this.currentUser.firstname + " " + this.currentUser.lastname,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: "MENU.BARGAINING_LIST",
              isLink: true,
              link: "/dashboard/bargaining-list",
            },
            {
              name: italian.data.CREATE_BARGAINING + " " + italian.data.FOR + " " + this.currentUser.firstname + " " + this.currentUser.lastname,
              isLink: false,
            },
          ],
        },
      };
    }
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }

  isDisabledSave() {
    if (this._contractManager.data.contract === 4) {
      //Controllo in caso di contratto a stage
      if (
        this._contractManager.data.role === "" ||
        this._contractManager.data.contract < 1 ||
        this._contractManager.data.net_monthly_12 < 1 ||
        this._contractManager.data.total_daily < 1 ||
        this._contractManager.data.start_date === "" ||
        !this._contractManager.data.tutor_hash ||
        !this._contractManager.data.end_date
      ) {
        return true;
      }
      return false;
    }

    if (
      this._contractManager.data.level === "" ||
      this._contractManager.data.role === "" ||
      this._contractManager.data.contract < 1 ||
      this._contractManager.data.gross_monthly_12 < 1 ||
      this._contractManager.data.trial === "" ||
      this._contractManager.data.net_monthly_12 < 1 ||
      this._contractManager.data.net_monthly_13 < 1 ||
      this._contractManager.data.total_net_monthly_13 < 1 ||
      this._contractManager.data.salary_yearly_gross < 1 ||
      this._contractManager.data.total_daily < 1 ||
      this._contractManager.data.start_date === "" ||
      this._contractManager.data.start_date === null
    ) {
      return true;
    }
    if (this._contractManager.data.contract === 3 && !this._contractManager.data.tutor_hash) {
      return true;
    }
    if (this._contractManager.data.contract !== 1 && !this._contractManager.data.end_date) {
      return true;
    }
    return false;
  }

  async submit() {
    if (!this._authenticationService.hasCapability("create_bargaining")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this._contractManager.data.start_date == null) {
      await this._utilService.showToastrError("INSERT_START_DATE");
      return false;
    }
    let data = {
      bonus: String(this._contractManager.data.bonus),
      production_bonus: String(this._contractManager.data.production_bonus),
      contract: this._contractManager.data.contract,
      end_date: this._contractManager.data.end_date,
      gross_monthly_12: this._contractManager.data.gross_monthly_12,
      level: this._contractManager.data.level,
      net_monthly_12: this._contractManager.data.net_monthly_12,
      net_monthly_13: this._contractManager.data.net_monthly_13,
      program: this._contractManager.data.program,
      request_id: Number(this.idRequest),
      role: this._contractManager.data.role,
      salary_yearly_gross: this._contractManager.data.salary_yearly_gross,
      start_date: this._contractManager.data.start_date,
      ticket_month_number: this._contractManager.data.ticket_month_number,
      ticket_type: this._contractManager.data.ticket_type,
      ticket_value: String(this._contractManager.data.ticket_value),
      total_daily: this._contractManager.data.total_daily,
      total_net_monthly_13: this._contractManager.data.total_net_monthly_13,
      trial: this._contractManager.data.trial,
      tutor_hash: this._contractManager.data.tutor_hash,
      user_hash: this.currentUser.hash,
      company_office_id: this._contractManager.data.company_office_id,
    };

    // Controllo in caso di contratto a stage elimino campi superflui
    if (this._contractManager.data.contract === 4) {
      data.bonus = null;
      data.production_bonus = null;
      data.gross_monthly_12 = null;
      data.level = null;
      data.net_monthly_13 = null;
      data.salary_yearly_gross = null;
      data.ticket_month_number = null;
      data.ticket_type = null;
      data.ticket_value = null;
      data.total_net_monthly_13 = null;
      data.trial = null;
    }

    if (!data.end_date || data.end_date.length < 1) {
      data.end_date = null;
    }

    if (data.contract !== 1) {
      // if (data.end_date <= moment(data.start_date).add(data.trial, "days").format("YYYY-MM-DD")) {
      //   await this._utilService.showToastrError("CONTROL_CONTRACT_DATE");
      //   return false;
      // }
    }

    this._utilService.showLoading();
    await this._bargainingService
      .createBragaining(data)
      .then(async (result: any) => {
        this._utilService.hideLoading();
        await this._utilService.showToastrSuccess("SUCCESS_SEND_BARGAINING");
        await this._router.navigateByUrl(`/dashboard/edit-bargaining/${result.id}`);
      })
      .catch(async (err: any) => {
        this._utilService.hideLoading();
        if (String(err) == "User already in bargaining") {
          await this._utilService.showToastrError("USER_ALREADY_IN_BARGAINING");
        }
        if (String(err) == "Email already exist") {
          await this._utilService.showToastrError("email_address_already_in_use");
        } else {
          await this._utilService.showToastrError("ERROR_SEND_BARGAINING");
        }
      });
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  calculateTicketTotalMonth() {
    const ticketValue = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_value.toString());
    const ticketMonthNumber = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_month_number.toString());
    return this._utilService.addDotsToNumber(ticketValue * ticketMonthNumber);
  }
}
